import React, { useState, useEffect } from 'react'

const CompanyRow = ({company}) => {
  return (
    <tr>
      <td>
        <div className='company-title' onClick={() => window.location.href =`/admins/companies/${company.id}`}>
          <span>{company.name}</span>
        </div>
      </td>
      <td>
        <div className='company-status'>
          <span>{company.status == 'production' ? 'Existing' : 'Potential'}</span>
        </div>
      </td>
      <td>
        <div className='company-locations-count'>
          <span>{company.locations_count}</span>
        </div>
      </td>
      <td>
        <div className='company-fields-count'>
          <span>{company.fields_count}</span>
        </div>
      </td>
      <td>
        <div className='company-regions-count'>
          <span>{company.regions_count}</span>
        </div>
      </td>
      <td>
        <div className='company-region'>
          <span>{company.region}</span>
        </div>
      </td>
    </tr>
  )
}

export default CompanyRow
